import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../ui/card';
import { ROLE_COLORS, ROLE_NAMES } from '../adminConstants';

/**
 * Roles tab body for the Admin Dashboard. Read-only summary of role
 * definitions with their canonical colors and capabilities.
 */
export default function RolesTab() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Role Definitions</CardTitle>
        <CardDescription>View role permissions and capabilities</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {Object.entries(ROLE_COLORS).map(([roleId, config]) => {
            const RoleIcon = config.icon;
            return (
              <div
                key={roleId}
                className={`p-4 rounded-lg border ${config.bg}`}
                data-testid={`admin-role-card-${roleId}`}
              >
                <div className="flex items-center gap-3 mb-3">
                  <RoleIcon size={24} className={config.text} />
                  <div>
                    <h3 className={`font-semibold ${config.text}`}>{ROLE_NAMES[roleId]}</h3>
                    <p className="text-sm text-gray-600">
                      {roleId === 'super_admin' &&
                        'Full system access across all organizations'}
                      {roleId === 'org_admin' && 'Full access within their organization'}
                      {roleId === 'user' && 'Standard user access within their organization'}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
